import { Injectable } from '@angular/core';

@Injectable()
export class RegexService{
    readonly passwordRegex: string = '(?=.{14,})((?=.*\\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\\d)(?=.*[a-zA-Z])(?=.*[\\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\\W_])).*';
}